<div class="datatable datatable-hover">
  <div class="datatable-header">
    <div class="datatable-header-item col-1"></div>
    <div class="datatable-header-item col">{{ ('General.Payment_Method' | trans) }}</div>
    <div class="datatable-header-item col">{{ ('General.Person' | trans) }}</div>
    <div class="datatable-header-item col">{{ ('Order.Order_Number' | trans) }}</div>
    <div class="datatable-header-item col">{{ ('General.Tickets' | trans) }}</div>
    <div class="datatable-header-item col">{{ ('General.Amount' | trans) }}</div>
  </div>

  @if (payments) {
    @for (payment of payments; track payment) {
      <div class="datatable-row" [class.fade-out]="isLoading" [routerLink]="['/orders', payment.orderId]">
        <div class="datatable-row-item col-1" [cm-tooltip]="payment.status">
          @if (payment.status === 'OPEN') {
            <span class="f-s-15 cm-icon cm-icon-time-fill cl-warning-color"
            aria-hidden="true"></span>
          }
          @if (payment.status === 'SUCCESS') {
            <span
            class="f-s-15 cm-icon cm-icon-verification cl-success-color" aria-hidden="true"></span>
          }
          @if (payment.status === 'EXPIRED') {
            <span class="f-s-15 cm-icon cm-icon-time-fill cl-error-color"
            aria-hidden="true"></span>
          }
          @if (payment.status === 'CANCELED') {
            <span class="f-s-15 cm-icon cm-icon-error cl-error-color"
            aria-hidden="true"></span>
          }
          @if (payment.status === 'FAILED') {
            <span class="f-s-15 cm-icon cm-icon-error cl-error-color"
            aria-hidden="true"></span>
          }
        </div>
        <div class="datatable-row-item col">
          @if (payment.method.toUpperCase() === 'IDEAL') {
            <span [cm-tooltip]="payment.method"
            class="cm-payment cm-payment-ideal vertical-middle" aria-hidden="true"></span>
          }
          @if (payment.method === 'BANCONTACT') {
            <span [cm-tooltip]="payment.method"
            class="cm-payment cm-payment-bancontact vertical-middle" aria-hidden="true"></span>
          }
          @if (payment.method === 'SOFORT_BANKING') {
            <span [cm-tooltip]="payment.method"
            class="cm-payment cm-payment-sofort vertical-middle" aria-hidden="true"></span>
          }
          @if (payment.method === 'MASTER_CARD') {
            <span [cm-tooltip]="payment.method"
            class="cm-payment cm-payment-mastercard vertical-middle" aria-hidden="true"></span>
          }
          @if (payment.method === 'VISA_CARD') {
            <span [cm-tooltip]="payment.method"
            class="cm-payment cm-payment-visa vertical-middle" aria-hidden="true"></span>
          }
          @if (payment.method === 'BANK_TRANSFER') {
            <span [cm-tooltip]="payment.method"
            class="cm-payment cm-payment-bank-transfer vertical-middle" aria-hidden="true"></span>
          }
          @if (payment.method === 'APPLE_PAY') {
            <span [cm-tooltip]="payment.method"
            class="cm-payment cm-payment-apple-pay vertical-middle" aria-hidden="true"></span>
          }
          @if (payment.method === 'GOOGLE_PAY') {
            <span [cm-tooltip]="payment.method"
            class="cm-payment cm-payment-google-pay-official vertical-middle" aria-hidden="true"></span>
          }
          <span class="m-l-8">{{ payment.method }}</span>
        </div>
        <div class="datatable-row-item col">{{ payment.actor?.name }}</div>
        <div class="datatable-row-item col">{{ payment.order.batchId }}</div>
        <div class="datatable-row-item col">{{ payment.order.orderItemAmount | number }}</div>
        <div class="datatable-row-item col">{{ payment.balance | currency:payment.currency }}</div>
      </div>
    }
  } @else {
    <cm-indicator class="small"></cm-indicator>
  }
</div>

